export default ([minLon, minLat, maxLon, maxLat]) => ({
  type: 'Polygon',
  coordinates: [
    [
      [minLon, minLat],
      [maxLon, minLat],
      [maxLon, maxLat],
      [minLon, maxLat],
      [minLon, minLat],
    ],
  ],
});
